import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Alert, Container } from '@mui/material';

import { AppBgColor } from '../config/DiactiveTheme';
import { verifyQuestionnaireToken } from '../services/FunctionService';
import { QuestionnaireMode, UnityPaths } from '../config/DiactiveTypes';
import Questionnaire from '../components/questionnaires/Questionnaire';

const EmbedQuestionnaire = () => {
  const { token } = useParams();
  const [questionnaireId, setQuestionnaireId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
   const validateToken = async () => {
      try {
        const payload = await verifyQuestionnaireToken(token);
        setQuestionnaireId(payload.questionnaireId);
        if (!payload.isValid) {
          setError('Enlace inválido, prueba otra vez');
          goBackToUnity();
        }
      }
      catch (error) {
        setError(error.message);
        goBackToUnity();
      }
      finally {
        setLoading(false);
      }
    };
    validateToken();
  }, [token]);

  useEffect(() => {
    document.body.style.backgroundColor = AppBgColor;
  }, []);

  const goBackToUnity = () => {
    setTimeout(() => {
      window.location.href = `uniwebview://${UnityPaths.QuestionnaireBack}`;
    }, 1500);
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: AppBgColor }}>
        <CircularProgress size={45} sx={{ color: '#fff' }} />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="sm" sx={{ pt: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }

  return (
    <Questionnaire
      mode={QuestionnaireMode.Embed_Fill}
      questionnaireId={questionnaireId}
      token={token}
    />
  );
};

export default EmbedQuestionnaire;